module.exports = __webpack_public_path__ + "static/media/icon-check.7b89b0d0.png";